import { useNavigate } from 'react-router-dom';
import { DropdownMenuItem } from '@c2fo/liquidity';
import { EyeIcon, PencilIcon } from '@c2fo/liquidity/icons';
import { Credential } from '../../api/Credentials';
import { CredentialTypeChip } from '../CredentialTypeChip';
import { DataGrid, DataGridCard } from '../DataGrid';
import { ActionsMenu } from '../ActionsMenu';
import { formatDateWithTimezone } from '../../../../utils/dateFormat';

interface CredentialGridProps {
  credentials: Credential[];
}

export const CredentialGrid: React.FC<CredentialGridProps> = ({ credentials }) => {
  const navigate = useNavigate();

  return (
    <DataGrid>
      {credentials.map((credential) => (
        <DataGridCard key={credential.uid}>
          <div className="flex items-center justify-between">
            <CredentialTypeChip credentialType={credential.credentialType} />
            <ActionsMenu>
              <DropdownMenuItem
                className="active:bg-lightBlue-100"
                onSelect={() => navigate(`/file-delivery/credentials/${credential.uid}`)}
              >
                <EyeIcon className="h-4 w-4 mr-2" />
                View Details
              </DropdownMenuItem>
              <DropdownMenuItem
                className="active:bg-lightBlue-100"
                onSelect={() => navigate(`/file-delivery/credentials/${credential.uid}/edit`)}
              >
                <PencilIcon className="h-4 w-4 mr-2" />
                Edit
              </DropdownMenuItem>
            </ActionsMenu>
          </div>

          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-gray-900 truncate">{credential.displayName}</span>
          </div>

          <div className="flex flex-col gap-1 text-xs text-gray-500">
            <div className="flex justify-between">
              <span>Created:</span>
              <span>{credential.createTime ? formatDateWithTimezone(credential.createTime) : '-'}</span>
            </div>
            <div className="flex justify-between">
              <span>Updated:</span>
              <span>{credential.updateTime ? formatDateWithTimezone(credential.updateTime) : '-'}</span>
            </div>
          </div>
        </DataGridCard>
      ))}
    </DataGrid>
  );
};
